import { render, staticRenderFns } from "./NumberOfResults.vue?vue&type=template&id=778c5753&scoped=true"
import script from "./NumberOfResults.vue?vue&type=script&lang=js"
export * from "./NumberOfResults.vue?vue&type=script&lang=js"
import style0 from "./NumberOfResults.vue?vue&type=style&index=0&id=778c5753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c5753",
  null
  
)

export default component.exports